import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import logisticsApi from '@utils/logisticsApi';
import { useI18n } from '@/i18n';
import PageHeader from '@components/PageHeader';
import { IconInbox, IconPlus } from '@components/icons';

export default function MyRequests() {
  const { t, lang } = useI18n();
  const [requests, setRequests] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [loadError, setLoadError] = useState(false);

  const load = () => {
    setLoadError(false);
    logisticsApi.get('/me/requests')
      .then(({ data }) => setRequests(data.requests || []))
      .catch(() => setLoadError(true))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  return (
    <>
      <PageHeader title={t('logisticsRequests.title')} subtitle={t('logisticsRequests.subtitle')} />
      <div className="px-5 md:px-0 pb-6">
        <Link to="/requests/new" className="btn-primary w-full mb-4 flex items-center justify-center gap-2">
          <IconPlus size={16} /> {t('logisticsRequests.new')}
        </Link>
        {loading ? (
          <div className="card p-8 text-center text-gray-400">{t('common.loading')}</div>
        ) : loadError ? (
          <div className="card p-10 text-center">
            <p className="text-sm text-red-600 mb-3">{t('logisticsRequests.errLoad')}</p>
            <button onClick={load} className="btn-ghost text-xs">{t('logisticsRequests.retry')}</button>
          </div>
        ) : requests.length === 0 ? (
          <div className="card p-10 text-center">
            <div className="mx-auto w-12 h-12 grid place-items-center rounded-xl bg-gray-100 text-gray-400 mb-3">
              <IconInbox size={24} />
            </div>
            <p className="text-sm text-gray-500">{t('logisticsRequests.empty')}</p>
          </div>
        ) : (
          <div className="space-y-2.5">
            {requests.map((r, i) => (
              <motion.div key={r.id}
                initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: i * 0.04 }}>
                <Link to={`/requests/${r.id}`} className="card p-4 flex items-center gap-4">
                  <span className="shrink-0 grid place-items-center w-10 h-10 rounded-xl bg-glk-blue/10 text-glk-blue">
                    <IconInbox size={20} />
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-glk-dark truncate">{r.justification}</p>
                    <p className="text-xs text-gray-400 truncate">
                      {t(`logisticsRequests.status.${r.status}`) || r.status} · {new Date(r.created_at).toLocaleDateString(lang === 'en' ? 'en-GB' : 'pt-PT')}
                    </p>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
